export default __webpack_public_path__ + "a25806274237d06e00a6888155519b98.woff2";